// https://app.growthbook.io/features/prcng-1270_v1
export const EXPERIMENT_FLAG = 'prcng-1270_v1'
